import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  getVideoByCategory,
  getPopularVideos,
} from "../../redux/actions/videos.action";

import "./Categories.css";

const keywords = [
  "All",
  "Reactjs",
  "Nodejs",
  "Coding",
  "Music",
  "Indie folk",
  "Food",
  "Pizza",
  "Live Concert",
  "Cricket",
  "Business",
  "Quiz",
  "FAANG",
  "Engineering",
  "MS Dhoni",
  "Bollywood songs",
  "serial songs",
];

const Categories = () => {
  const [activeElement, setActiveElement] = useState("All");
  const dispatch = useDispatch();

  const handleClick = (value) => {
    setActiveElement(value);
    if (value === "All") {
      dispatch(getPopularVideos());
    } else {
      dispatch(getVideoByCategory(value));
    }
  };

  return (
    <div className="categories">
      {keywords.map((value, i) => (
        <span
          key={i}
          onClick={() => handleClick(value)}
          className={activeElement === value ? "active" : ""}
        >
          {value}
        </span>
      ))}
    </div>
  );
};

export default Categories;
